module.exports = __webpack_public_path__ + "assets/thumb-urgent@2x.8449eb02.png";